/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface LearningCompetenceDTO
 */
export interface LearningCompetenceDTO {
    /**
     * 
     * @type {string}
     * @memberof LearningCompetenceDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetenceDTO
     */
    studyProgramId?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetenceDTO
     */
    studyPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetenceDTO
     */
    identificator?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetenceDTO
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof LearningCompetenceDTO
     */
    type?: LearningCompetenceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LearningCompetenceDTO
     */
    isDomainLearningOutcomeTemplate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetenceDTO
     */
    domainLearningOutcomeTemplateId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LearningCompetenceDTO
     */
    isCompetenceTemplate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetenceDTO
     */
    competenceTemplateId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LearningCompetenceDTO
     */
    isCompetenceTemplateAssociatedOutcome?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LearningCompetenceDTO
     */
    associatedResultTemplateId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LearningCompetenceDTO
     */
    learnings?: Array<string> | null;
}

export function LearningCompetenceDTOFromJSON(json: any): LearningCompetenceDTO {
    return LearningCompetenceDTOFromJSONTyped(json, false);
}

export function LearningCompetenceDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningCompetenceDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'studyPlanId': !exists(json, 'studyPlanId') ? undefined : json['studyPlanId'],
        'identificator': !exists(json, 'identificator') ? undefined : json['identificator'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
        'isDomainLearningOutcomeTemplate': !exists(json, 'isDomainLearningOutcomeTemplate') ? undefined : json['isDomainLearningOutcomeTemplate'],
        'domainLearningOutcomeTemplateId': !exists(json, 'domainLearningOutcomeTemplateId') ? undefined : json['domainLearningOutcomeTemplateId'],
        'isCompetenceTemplate': !exists(json, 'isCompetenceTemplate') ? undefined : json['isCompetenceTemplate'],
        'competenceTemplateId': !exists(json, 'competenceTemplateId') ? undefined : json['competenceTemplateId'],
        'isCompetenceTemplateAssociatedOutcome': !exists(json, 'isCompetenceTemplateAssociatedOutcome') ? undefined : json['isCompetenceTemplateAssociatedOutcome'],
        'associatedResultTemplateId': !exists(json, 'associatedResultTemplateId') ? undefined : json['associatedResultTemplateId'],
        'learnings': !exists(json, 'learnings') ? undefined : json['learnings'],
    };
}

export function LearningCompetenceDTOToJSON(value?: LearningCompetenceDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'studyProgramId': value.studyProgramId,
        'studyPlanId': value.studyPlanId,
        'identificator': value.identificator,
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
        'isDomainLearningOutcomeTemplate': value.isDomainLearningOutcomeTemplate,
        'domainLearningOutcomeTemplateId': value.domainLearningOutcomeTemplateId,
        'isCompetenceTemplate': value.isCompetenceTemplate,
        'competenceTemplateId': value.competenceTemplateId,
        'isCompetenceTemplateAssociatedOutcome': value.isCompetenceTemplateAssociatedOutcome,
        'associatedResultTemplateId': value.associatedResultTemplateId,
        'learnings': value.learnings,
    };
}

